import CustomViewsFallbackModeTooltip from './CustomViewsFallbackModeTooltip';
import LinkWrapper from './LinkWrapper';
import { useIsFallbackModeEnabled } from 'find-and-filter-data/views-data/public';
import { isHydratedCustomView } from 'find-and-filter-data/views-schema/public';
import { jsx as _jsx } from "react/jsx-runtime";
const NavViewLink = ({
  view,
  handleViewMemberClick,
  viewId,
  buttonContent,
  actions,
  wrapperEl
}) => {
  const customViewsFallbackModeEnabled = useIsFallbackModeEnabled();
  const disabled = isHydratedCustomView(view) && customViewsFallbackModeEnabled;
  return /*#__PURE__*/_jsx(CustomViewsFallbackModeTooltip, {
    disabled: disabled,
    children: /*#__PURE__*/_jsx(LinkWrapper, {
      disabled: disabled,
      view: view,
      handleViewMemberClick: handleViewMemberClick,
      viewId: viewId,
      buttonContent: buttonContent,
      actions: actions,
      wrapperEl: wrapperEl
    })
  });
};
NavViewLink.displayName = 'NavViewLink';
export default NavViewLink;